const baseURL = process.env.NODE_ENV === 'production' ? '' : 'api';
const ossUrl = 'http://img.xiaoqijiankang.com/images'
module.exports = {
  baseUrl: baseURL,
  ossUrl,
};